import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import {
  ErrorDetails,
  VehicleRequestDTO,
  AddVehicleResponseDTO
} from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";

export class UpdateVehicleCommand extends IRequestCommand<
  IUpdateVehicle,
  ErrorDetails,
  IUpdateVehicleCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'vehicles/{vehicleId}';
  public override setParameters(parameters: IUpdateVehicleCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{vehicleId}',
      parameters.vehicleId.toString()
    );
    this._commandBody = parameters;
  }
}

export interface IUpdateVehicleCommandParameters
  extends VehicleRequestDTO,
    ICommandParameters {
  vehicleId?: number;
}

export interface IUpdateVehicle
  extends AddVehicleResponseDTO,
    ICommandResponse {}
